import {BlockItemDrawProps} from "../FrameBlockItem";
import {lineBlueHeavy} from "../../../const";
import {ClickableFace, drawFace} from "./ClickableFace";
import {cellFill, fillColor} from "../../../shared-2d/CellFill";

// FixedFace is a solid (non-glazed) fixed panel. Sized like a LiteFace, but
// filled flat in its material's colour (grey metal / tan wood) instead of the
// glass gradient, so it's easy to tell apart from a glass lite while staying
// subtle. The panel's position isn't hatched here — it reads off the section in
// the frame profile view.
export class FixedFace extends ClickableFace {
    constructor() {
        super((props: BlockItemDrawProps) => {
            const g = props.graphics;
            g.clear();

            // normalize so the rect is well-formed regardless of start/end order.
            const left = Math.min(props.startX, props.endX);
            const right = Math.max(props.startX, props.endX);
            const top = Math.min(props.startY, props.endY);
            const bottom = Math.max(props.startY, props.endY);

            const w = right - left;
            const h = bottom - top;
            if (w <= 0 || h <= 0) return;

            const fill = cellFill(props.block);

            g.lineStyle(2, lineBlueHeavy, 1);
            g.beginFill(fillColor(fill.material), 1);
            drawFace(g, props, left, top, w, h);
            g.endFill();
        });
    }
}
